import React from 'react';

import { observer } from 'mobx-react';

import classes from './PriceInfo.module.scss';
import { CurrentPrice } from '../../../../components/checkout/CurrentPrice/CurrentPrice';
import { challengeCheckoutStore } from '../../../../stores/challengeCheckoutStore';

const PriceInfo = observer(() => {
  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { challenge, promocode, checkoutDetails } = challengeCheckoutInfo;

  const isPromocodeUsedToCurrentPayment =
    Boolean(promocode) && checkoutDetails.discountAmount !== 0;

  return (
    <div className={classes.container}>
      <p className={classes.title}>
        Pay for&nbsp;
        <span className={classes.challengeName}>{challenge.challengeName}</span>
      </p>
      <CurrentPrice
        price={challenge.priceFinal}
        hasDiscount={isPromocodeUsedToCurrentPayment}
        discountPercent={promocode?.discountPercent}
        oldPrice={challenge.price}
        suffix="/ one-time payment"
      />
    </div>
  );
});

export { PriceInfo };
